import '../../css/base.css';

const Kayaking = () => {

  return (
    <div>
      <h2 className="walks-section-heading">Kayaking</h2>
      <p className="walk-text">So many options to explore Loch Hourn.  East to Corran and the small island of Sgeir Leathan which often has seals basking on the rocks.
                              West to Dry Island and its secluded cove and round the corner to Eilean Rarsaidh and the other small isles.  Further afield you can explore to Barrisdale Bay and even
                              past the three narrowings to the end of Loch Hourn.                                  
      </p>                                            
    </div>
  );
}

export default Kayaking
